import { isBackdrop } from "./IXXFVVA2.js";
import { setProperty } from "./FW6QFGFT.js";
import { walkTreeOutside } from "./5M4ITSXL.js";

// src/dialog/utils/mark-tree-outside.ts
import { chain } from "@ariakit/core/utils/misc";
function getPropertyName() {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let ancestor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return "__ariakit-dialog-".concat(ancestor ? "ancestor" : "outside").concat(id ? "-".concat(id) : "");
}
function markElement(element) {
  let id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return chain(
  // Debug
  // setAttribute(element, getPropertyName(), "true"),
  // setAttribute(element, getPropertyName(id), "true"),
  setProperty(element, getPropertyName(), true), setProperty(element, getPropertyName(id), true));
}
function markAncestor(element) {
  let id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return chain(
  // Debug
  // setAttribute(element, getPropertyName("", true), "true"),
  // setAttribute(element, getPropertyName(id, true), "true"),
  setProperty(element, getPropertyName("", true), true), setProperty(element, getPropertyName(id, true), true));
}
function isElementMarked(element, id) {
  const ancestorProperty = getPropertyName(id, true);
  if (element[ancestorProperty]) return true;
  const elementProperty = getPropertyName(id);
  do {
    if (element[elementProperty]) return true;
    if (!element.parentElement) return false;
    element = element.parentElement;
  } while (true);
}
function markTreeOutside(dialogId) {
  const cleanups = [];
  for (var _len = arguments.length, elements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    elements[_key - 1] = arguments[_key];
  }
  const ids = elements.map(el => el == null ? void 0 : el.id);
  walkTreeOutside(elements, element => {
    if (isBackdrop(element, ...ids)) return;
    cleanups.unshift(markElement(element, dialogId));
  }, (ancestor, element) => {
    const isAnotherDialogAncestor = element.hasAttribute("data-dialog") && element.id !== dialogId;
    if (isAnotherDialogAncestor) return;
    cleanups.unshift(markAncestor(ancestor, dialogId));
  });
  const restoreAccessibilityTree = () => {
    cleanups.forEach(fn => fn());
  };
  return restoreAccessibilityTree;
}
export { markElement, markAncestor, isElementMarked, markTreeOutside };